import { REASON_FOR_SELLING_OPTIONS } from '../../../lib/constants';
import { useFormContext } from 'react-hook-form';
import { useFormDataContext } from '../../../lib/contexts';
import { useRef } from 'react';
import CustomBackButton from '../../CustomComponents/CustomBackButton';
import { useScrollToTop } from '../../../lib/hooks';

function FormStep3() {
  const { register, setValue, trigger, handleSubmit, formState } =
    useFormContext();
  const { updateFormData, formData, updateStep } = useFormDataContext();
  const { errors } = formState;
  const reason_for_sellingRef = useRef();

  const handleClick = (event) => {
    event.stopPropagation();
    if (event.target.type !== 'radio') {
      const input = event.currentTarget.querySelector('input[type="radio"]');
      input.click();
    }
  };

  const handleClickContinue = handleSubmit(async (_data) => {
    const isValid = await trigger(['reasonforselling']);

    if (!isValid) {
      const [firstErrorKey] = Object.keys(errors);
      const errorRefs = {
        reasonforselling: reason_for_sellingRef,
      };

      errorRefs[firstErrorKey]?.current?.focus();
    } else {
      // Assuming updateStep increments the step by 1
      updateStep(formData.step + 1); // Update step on radio select
    }
  });
  const handleRadioChange = async (e) => {
    await setValue('reasonforselling', e.target.value);
    updateFormData({ reasonforselling: e.target.value });
    handleClickContinue();
  };

  useScrollToTop();

  return (
    <>
      <div id="question3">
        <h3 className="step-title">Why Do You Want To Sell?</h3>
        <ul className="radio-list">
          {REASON_FOR_SELLING_OPTIONS.map(
            ({ id, value, textOption, registerLabel }, index) => (
              <li
                key={`${id}-${index}`}
                className={`radio-list-item ${
                  errors[registerLabel] && 'form-step__error'
                }`}
                onClick={handleClick}
              >
                <input
                  type="radio"
                  value={value}
                  id={id}
                  checked={formData.reasonforselling === value}
                  ref={reason_for_sellingRef}
                  {...register(registerLabel, { required: true })}
                  onClick={handleRadioChange}
                />
                <label className="radio-button">
                  <span htmlFor={id}>{textOption}</span>
                  <div className="radiobutton"></div>
                </label>
              </li>
            )
          )}
        </ul>
        <CustomBackButton/>
      </div>
    </>
  );
}
export default FormStep3;
